'use strict'

/**
 *
 * @name: nnVideoPlayerModal
 *
 */

import DirectiveTemplate from './nn-video-player-modal.directive.html'
import './nn-video-player-modal.directive.scss'

function NnVideoPlayerModalDirective () {

  'ngInject'

  return {
    restrict: 'E',
    replace: true,
    scope: true,
    template: DirectiveTemplate,
    controller: DirectiveController
  }
}

function DirectiveController ($scope, $rootScope, nnModalsService) {

  'ngInject'

  /*
   *
   * @CONFIG
   *
   */

  $scope.video = {}

  /*
   *
   * @PUBLIC
   *
   */


  /*
   *
   * @PRIVATE
   *
   */



  /*
   *
   * @INIT
   *
   */

  if ($rootScope.videoPlayerModalVideo) {
    $scope.video = $rootScope.videoPlayerModalVideo
  } else {
    nnModalsService.hideModal('videoPlayerModal')
  }
}

export default NnVideoPlayerModalDirective



// WEBPACK FOOTER //
// ./app/components/nn-modals/nn-video-player-modal/nn-video-player-modal.directive.js